import {
  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label
} from "reactstrap";

import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";

export default function DatePickerComponent({
  label,
  containerClass,
  containerStyle = {},
  onChange,
  date,
  placeholder,
  timeIntervals = 30,
  showTimeSelect = false,
  dateFormat = "dd/MM/yyyy",
  ...rest
}) {
  return (
    <FormGroup style={containerStyle} className={containerClass}>
      {label && <Label>{label}</Label>}
      <InputGroup style={{ flexWrap: "nowrap" }}>
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <FontAwesomeIcon icon={["far", "calendar-alt"]} />
          </InputGroupText>
        </InputGroupAddon>
        <DatePicker
          className="form-control"
          placeholderText={placeholder}
          required={true}
          selected={date}
          value={date}
          timeIntervals={timeIntervals}
          onChange={(date) => onChange(date)}
          dateFormat={dateFormat}
          showTimeSelect={showTimeSelect}
          {...rest}
        />
      </InputGroup>
    </FormGroup>
  );
}

DatePickerComponent.defaultProps = {
  onChange: () => { },
  date: new Date(),
  label: ""
};

DatePickerComponent.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func,
  date: PropTypes.any,
  containerStyle: PropTypes.any
};
